// @ts-strict-ignore
import mapValues from 'lodash/mapValues';

import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {WarehouseImport} from 'common/widgets/warehouse-import-builder/types';
import {getProjectId} from 'common/report/util';

import {appApiUrl} from '../utils';

function getUrl() {
  return appApiUrl(`warehouse-sources/imports`, {projectId: getProjectId()});
}

export function whImportContextMap(whImports: WarehouseImport[] | null) {
  if (!whImports) {
    return null;
  }

  return whImports.reduce((acc, whImport) => {
    acc[whImport.id] = whImport;

    return acc;
  }, {});
}

export const warehouseDataClient: ApiResourceClient<WarehouseImport> = {
  index() {
    const fetches = apiClient.hydratedGet<WarehouseImport[]>(getUrl());

    return mapValues(fetches, (whFetch) => whFetch.then(whImportContextMap));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: getUrl()});
  },
};
